import styled from 'styled-components';

export const ToolbarWrapper = styled.div`
  display: flex;
  gap: 16px;
  padding-top: 4px;
`;
